import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=9d2564e6&scoped=true"
import script from "./partnerList.vue?vue&type=script&lang=js"
export * from "./partnerList.vue?vue&type=script&lang=js"
import style0 from "./partnerList.vue?vue&type=style&index=0&id=9d2564e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2564e6",
  null
  
)

export default component.exports